module.exports = __webpack_public_path__ + "static/media/logo-jati.db732847.png";